import React, { useState } from "react";
import * as HERBUI from 'react-bootstrap'
import { FaFileAlt, FaUserCog, FaUsersCog, FaHandPointRight, FaUsers } from "react-icons/fa";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization } from "../Api/CommonAjaxUtils";
import { AWS_DOWNLOAD_URL } from "../Api/APIURLS";
import {
    usermanualscdm, usermanualsCER, usermanualscontract, usermanualsEL, usermanualsEsr, usermanualsEVigil, usermanualsgpf, usermanualsHRM,
    usermanualshrpayroll, usermanualspension, usermanualsPO, usermanualsvehicles
} from "../components/Functions";
import Header from "./Header";
import { FaDownload } from "react-icons/fa";
import { BsPlayCircleFill } from "react-icons/bs";
import { nodalOfficers } from "./NodalOfficers";


function NidhiUserManuals() {

    const [activeMenu, setActiveMenu] = useState("TechnicalTeamSupport");
    const menuTitles = {
        TechnicalTeamSupport: "Technical Supporting Team Contact Numbers",
        ESR: "e-SR Module",
        GPF: "GPF User Manuals",
        Pension: "Pension(RBPS) User Manuals",
        Contract: "Contract Payroll User Manuals",
        HRM: "eHRM User Manuals",
        PSE: "PSE (Public Sector Entities) HR & Payroll Module",
        Vehicles: "Vehicle Management",
        EL: "User Manual – Encashment of Earned Leave (EL)",
        CER: "Contract Employees Regularization",
        PO: "PO2025 Usermanuals",
        Evigil: "e-Vigil Usermanuals",
        

    };
    const getS3UrlData = async (url) => {
        const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(AWS_DOWNLOAD_URL + url);
        if (resp) { window.open(resp, "_blank"); }
    }
    return (
        <>
            <Header />
            <div className="inner-herbpage-service-title-sub-np" style={{ marginTop: "90px" }}>
                <h1 style={{ fontSize: "30px", marginLeft: "15px" }}>Circulars & User manuals</h1>
            </div>
            <div className="manual-layout">
                {/* Sidebar */}
                <div className="manual-sidebar">
                    <div className={`sidebar-item ${activeMenu === "TechnicalTeamSupport" ? "active" : ""}`}
                        onClick={() => setActiveMenu("TechnicalTeamSupport")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("TechnicalTeamSupport")
                            }
                        }}>
                        <div>
                            <FaUsersCog className="sidebar-icon fs-1" /></div>
                        <span>Technical Supporting Team Contact Numbers(for CFMS & Nidhi Portals)</span>
                    </div>


                    <div className={`sidebar-item ${activeMenu === "ESR" ? "active" : ""}`}
                        onClick={() => setActiveMenu("ESR")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("ESR")
                            }
                        }}>
                        <FaUserCog className="sidebar-icon" />
                        <span>e-SR(2.0) USER MANUALS</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "GPF" ? "active" : ""}`}
                        onClick={() => setActiveMenu("GPF")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("GPF")
                            }
                        }}>
                        <FaUserCog className="sidebar-icon" />
                        <span>GPF USER MANUALS</span>
                    </div>

                    <div className={`sidebar-item ${activeMenu === "Pension" ? "active" : ""}`}
                        onClick={() => setActiveMenu("Pension")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("Pension")
                            }
                        }} >
                        <FaFileAlt className="sidebar-icon" />
                        <span>Pension(RBPS) User Manual</span>
                    </div>
                    <div
                        className={`sidebar-item ${activeMenu === "Contract" ? "active" : ""}`}
                        onClick={() => setActiveMenu("Contract")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("Contract")
                            }
                        }}>
                        <FaFileAlt className="sidebar-icon" />
                        <span>Contract Payroll User Manual</span>
                    </div>

                    <div className={`sidebar-item ${activeMenu === "HRM" ? "active" : ""}`}
                        onClick={() => setActiveMenu("HRM")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("HRM")
                            }
                        }}>
                        <FaUserCog className="sidebar-icon" />
                        <span>eHRM USER MANUALS</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "PO" ? "active" : ""}`}
                        onClick={() => setActiveMenu("PO")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("PO")
                            }
                        }}>
                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>PO2025 User Manuals</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "PSE" ? "active" : ""}`}
                        onClick={() => setActiveMenu("PSE")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("PSE")
                            }
                        }}>
                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>Public Sector Entities USER MANUALS</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "Vehicles" ? "active" : ""}`}
                        onClick={() => setActiveMenu("Vehicles")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("Vehicles")
                            }
                        }}>
                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>Vehicle Management</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "EL" ? "active" : ""}`}
                        onClick={() => setActiveMenu("EL")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("EL")
                            }
                        }}>
                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>Encashment of Earned Leave (EL)</span>
                    </div>
                    <div className={`sidebar-item ${activeMenu === "CER" ? "active" : ""}`}
                        onClick={() => setActiveMenu("CER")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("CER")
                            }
                        }}>
                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>Contract Employees Regularization (CER)</span>
                    </div>

                    <div className={`sidebar-item ${activeMenu === "Evigil" ? "active" : ""}`}
                        onClick={() => setActiveMenu("Evigil")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setActiveMenu("Evigil")
                            }
                        }}>

                        <div>
                            <FaUsers className="sidebar-icon" /></div>
                        <span>e-Vigil Usermanuals</span>
                    </div>
                   
                </div>

                {/* Main Content */}
                <div className="manual-content">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="inner-herbpage-service-title-sub-np">
                            <h1 style={{ fontSize: "22px" }}>
                                {menuTitles[activeMenu] || "User Manuals"}
                            </h1>
                        </div>

                        <button className="btn btn-danger btn-sm"
                            onClick={() => window.history.back()}>
                            ✖ Close
                        </button>
                    </div>
                    {activeMenu === "TechnicalTeamSupport" && (
                        <HERBUI.Table bordered hover responsive className="text-center table-sm">
                            <thead style={{
                                fontSize: "13px", textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                            }} className="table table-hover table-bordered table-sm" >
                                <tr>
                                    <th>SL.NO</th>
                                    <th>NAME</th>
                                    <th>MOBILE NUMBER</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>1</td><td>Bharth</td><td>9966263536</td></tr>
                                <tr><td>2</td><td>Srinivas</td><td>9000316346</td></tr>
                                <tr><td>3</td><td>Venkat</td><td>8008944387</td></tr>
                                <tr><td>4</td><td>Ruby</td><td>7995503984</td></tr>
                                <tr><td>5</td><td>Mounika</td><td>8008862087</td></tr>
                                <tr><td>6</td><td>Soundarya</td><td>9676075867</td></tr>
                                <tr><td>7</td><td>Bhagya</td><td>9063363117</td></tr>
                                <tr><td>8</td><td>Kalyani</td><td>8985787635</td></tr>
                            </tbody>
                        </HERBUI.Table>
                    )}
                    {activeMenu === "Pension" && (
                        <HERBUI.Container fluid className="bg-white" style={{ width: "100%" }}>
                            <HERBUI.Row className="p-4">
                                <HERBUI.Accordion defaultActiveKey="0">

                                    <HERBUI.Accordion.Item>
                                        <HERBUI.Accordion.Header>
                                            <FaHandPointRight style={{ marginRight: "8px", color: "red" }} />
                                            <b> Pension Support Details</b>
                                        </HERBUI.Accordion.Header>

                                        <HERBUI.Accordion.Body>
                                            <HERBUI.Row>

                                                {/* ===== Nodal Officers Table ===== */}
                                                <h6 className="mb-2"><b>Nodal Officers</b></h6>
                                                <HERBUI.Table bordered hover responsive className="table-sm">
                                                    <thead className="table table-hover table-bordered table-sm text-center">
                                                        <tr>
                                                            <th>SL.NO</th>
                                                            <th>Name of the District</th>
                                                            <th>Name of the Nodal Officer</th>
                                                            <th>Designation</th>
                                                            <th>Mobile No.</th>
                                                            <th>E - Mail Id.</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {nodalOfficers.map((item) => {
                                                            if (item.sl === 27) {
                                                                return (
                                                                    <React.Fragment key="dta-heading">
                                                                        <tr>
                                                                            <td colSpan={6} className="text-center fw-bold bg-light">
                                                                                <span style={{ color: 'red' }}> At DTA office</span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr key={item.sl}>
                                                                            <td className="text-center">{item.sl}</td>
                                                                            <td>{item.district}</td>
                                                                            <td>{item.officer}</td>
                                                                            <td className="text-center">{item.designation}</td>
                                                                            <td className="text-center">{item.mobile}</td>
                                                                            <td>{item.email}</td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                            return (
                                                                <tr key={item.sl}>
                                                                    <td className="text-center">{item.sl}</td>
                                                                    <td>{item.district}</td>
                                                                    <td>{item.officer}</td>
                                                                    <td className="text-center">{item.designation}</td>
                                                                    <td className="text-center">{item.mobile}</td>
                                                                    <td>{item.email}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </HERBUI.Table>

                                                {/* ===== Technical Team ===== */}
                                                <h6 className="mb-2"><b>Technical Supporting Team Contact Numbers</b></h6>
                                                <HERBUI.Table bordered hover responsive className="text-center table-sm">
                                                    <thead className="table table-hover table-bordered table-sm">
                                                        <tr>
                                                            <th>SL.NO</th>
                                                            <th>NAME</th>
                                                            <th>MOBILE NUMBER</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr><td>1</td><td>Venkat</td><td>8008944387</td></tr>
                                                        <tr><td>2</td><td>Soundarya</td><td>9676075867</td></tr>
                                                        <tr><td>3</td><td>Gopi</td><td>8374302252</td></tr>
                                                    </tbody>
                                                </HERBUI.Table>

                                                <hr className="my-4" />
                                            </HERBUI.Row>
                                        </HERBUI.Accordion.Body>

                                    </HERBUI.Accordion.Item>

                                </HERBUI.Accordion>
                            </HERBUI.Row>
                        </HERBUI.Container>
                    )}
                    {activeMenu !== "TechnicalTeamSupport"  && (<table className="table table-bordered">
                        <thead className="table-primary">
                            <tr>
                                <th>S.No</th>
                                <th>Description</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(activeMenu === "ESR" ? usermanualsEsr : activeMenu === "GPF" ? usermanualsgpf : activeMenu === "Pension" ? usermanualspension : activeMenu === "Contract" ? usermanualscontract
                                : activeMenu === "HRM" ? usermanualsHRM : activeMenu === "PSE" ? usermanualshrpayroll
                                    : activeMenu === "Vehicles" ? usermanualsvehicles : activeMenu === "EL"
                                        ? usermanualsEL : activeMenu === "CER" ? usermanualsCER : activeMenu === "PO"
                                            ? usermanualsPO : activeMenu === "Evigil"
                                                ? usermanualsEVigil
                                                : []).map((sec, idx) => (
                                                    <tr key={idx}>
                                                        <td className="text-center">{idx + 1}</td>
                                                        <td>{sec.title}</td>
                                                        {/* {
                                                                activeMenu === "PO" &&
                                                                <td className="text-center">
                                                                    {
                                                                        sec.videoLink !== "-" ? <a href={sec.videoLink} target="_blank" rel="noopener noreferrer" className="link-button">
                                                                            <BsPlayCircleFill style={{ marginRight: "6px" }} />
                                                                        </a> : "-"
                                                                    }

                                                                </td>
                                                            } */}

                                                        <td className="text-center">
                                                            {activeMenu === "Evigil" ? (
                                                                sec.videoLink ? (
                                                                    <a
                                                                        href={sec.videoLink}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        Link
                                                                    </a>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => getS3UrlData(sec.downloadUrl)}
                                                                        className="link-button"
                                                                    >
                                                                        <FaDownload style={{ marginRight: "5px" }} />

                                                                    </button>
                                                                )
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => getS3UrlData(sec.downloadUrl)}
                                                                    className="link-button"
                                                                >
                                                                    <FaDownload />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                        </tbody>
                    </table>
                    )}
                    {(activeMenu === "ESR") && (
                        <div className="alert alert-info mt-3">
                            <h5><b>e-SR 2.0 Technical Support</b></h5>

                            <p>
                                If you encounter any <b>technical issues</b> while using
                                <b> e-SR 2.0</b>, such as login problems, application errors,
                                workflow issues, data-related issues, screen loading problems,
                                or any other system-related concerns, please contact the
                                e-SR 2.0 technical support team.
                            </p>

                            <h6><b>Technical Support Contacts:</b></h6>

                            <HERBUI.Table bordered hover responsive className="text-center table-sm bg-white">
                                <thead className="table table-hover table-bordered table-sm bg-white">
                                    <tr>
                                        <th>SL.NO</th>
                                        <th>NAME</th>
                                        <th>MOBILE NUMBER</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>1</td><td>Ruby</td><td>7995503984</td></tr>
                                    <tr><td>2</td><td>Mounika</td><td>8008862087</td></tr>
                                    <tr><td>3</td><td>Soundarya</td><td>9676075867</td></tr>
                                </tbody>
                            </HERBUI.Table>

                            <p>
                                Before reporting an issue, please keep the following details ready
                                to help us resolve it quickly:
                            </p>

                            <ul>
                                <li>Employee/CFMS ID</li>
                                <li>Office/DDO Code (if applicable)</li>
                                <li>Module/Screen Name</li>
                                <li>Brief description of the issue</li>
                                <li>Screenshot or error message (if available)</li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
export default NidhiUserManuals;
